import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { API_URL_V4 } from 'src/environments/environment.local';
import { Tag } from '../models/tag.interface';
import { ApiHttpResponse } from '@kinomap-dev/ng-ui-lib';

@Injectable({ providedIn: 'root' })
export class TagApi {
  private readonly tagUrl = `${API_URL_V4}/tags`;

  constructor(private http: HttpClient) { }

  getTags$(): Observable<Tag[]> {
    return this.http.get<ApiHttpResponse<Tag[]>>(this.tagUrl).pipe(
      map((res: ApiHttpResponse<Tag[]>) => {
        return res.data.map((item: Tag) => {
          return item;
        });
      })
    );
  }
}
